import React from 'react';

export interface BrowserFeatureProps {
  supportsWebp: boolean;
  supportsLazy: boolean;
}

export const BrowserFeatureContext = React.createContext<BrowserFeatureProps>({
  supportsWebp: false,
  supportsLazy: false,
});
BrowserFeatureContext.displayName = 'BrowserFeatureContext';
